import {
  useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';

function useDeviceData() {

  const [infoDevice, setInfoDevice] = useState({});
  const generalDeviceInfo = useSelector(({ telemetry: tel }) => tel.generalDeviceInfo);

  useEffect(() => {

    setInfoDevice(generalDeviceInfo);

  }, [generalDeviceInfo]);

  return {
    infoDevice,
  };

}

export default useDeviceData;
